// Breakpoints
export const BREAKPOINT_DOWN_SMALL = "(max-width: 767px)";
export const BREAKPOINT_UP_MEDIUM = "(min-width: 1025px)";
export const BREAKPOINT_DOWN_MEDIUM = "(max-width: 1024px)";

export let BACKEND_ROOT;
export let FRONTEND_ROOT;

export const IS_PROD = ["production", "staging"].includes(process.env.ENV);

switch (process.env.ENV) {
  case "production":
    BACKEND_ROOT = "https://api.axios.com";
    FRONTEND_ROOT = "https://www.axios.com";
    break;
  case "staging":
    BACKEND_ROOT = "https://api-stage.axios.com";
    FRONTEND_ROOT = "https://firstorder-stage.axios.com";
    break;
  default:
    BACKEND_ROOT = "http://localhost:8000";
    FRONTEND_ROOT = "http://localhost:3006";
    break;
}

export const API_ROOT = `${BACKEND_ROOT}/api/render/`;

export const EVENTS_API = "https://eventsdata.axios.com/upcoming-events.json";

// Draft js
export const BLOCK_TYPE = {
  EMBED: "embed",
  KEEP_READING: "keep-reading",
  QUOTE_ATTRIBUTION: "quote-attribution",
  STYLED_QUOTE: "styled-quote",
};

export const STYLE_TYPE = {
  BOLD: "bold",
  ITALIC: "italic",
};

export const ENTITY_TYPE = {
  LINK: "link",
};

export const GA_TRACKED_LINK_TYPE = {
  SAVE: "save",
  LINK: "links",
  READ_MORE: "readmore",
  READ_ANOTHER: "readanother",
  SS_CL: "socialshare_cl",
  SS_FB: "socialshare_fb",
  SS_TW: "socialshare_tw",
  SS_LI: "socialshare_li",
};

export const URL_ID_REGEXP = "([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|[0-9]+)";

export const RAVEN_DSN = "https://589defa5381d4ba9a9b7a640591f8d6c@sentry.io/247977";



// WEBPACK FOOTER //
// ./src/config/constants.js